/* eslint-disable */
import axios from 'axios'
import store from '@/store'

const DO_SPACES_BASE = 'https://woohelps.sgp1.digitaloceanspaces.com'

const getPresignedUrl = (userId, fileType, fileName, contentType) => {
  return axios({
    method: 'get',
    url: '/api/applet/aws/generate-presigned-url',
    params: {
      userId: userId,
      fileType: fileType,
      fileName: fileName,
      contentType: contentType
    }
  })
}

export async function uploadFile (file, fileType = 1) {
  const userId = store.state.userInfo ? store.state.userInfo.id : 'admin'
  const type = ['image', 'audio', 'video'][fileType - 1]
  const fileName = Date.now() + '-' + (file.name || file.size)
  const contentType = file.type || 'application/octet-stream'

  const presigned = await getPresignedUrl(userId, type, fileName, contentType)

  const formdata = new FormData()
  Object.keys(presigned.fields).forEach(key => {
    formdata.append(key, presigned.fields[key])
  })
  formdata.append('file', file)

  await axios.post(presigned.url, formdata)

  return DO_SPACES_BASE + '/' + presigned.fields.key
}

export const searchCities = keyword => axios.get('/api/applet/city/search', { params: { keyword } })

export const getCityInfo = city_id => axios.get('/api/applet/city/info/get', { params: { city_id } })



// WEBPACK FOOTER //
// ./src/api/common.js